import React from 'react';
import { motion } from 'framer-motion';
import '../assets/styles/About.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <motion.div
          className="about-text"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h2>About Us</h2>
          <p>A small company founded by 2 engineers, with expertise in:</p>

          <div className="about-expertise">
            <div className="expertise-group">
              <h4>Process (Chemical)</h4>
              <ul>
                <li>Water treatment – mine water, seawater desalination, water reuse</li>
                <li>Experienced (&gt;15yrs) in full project life cycle: feasibility to operations</li>
                <li>Special interest in membrane systems</li>
              </ul>
            </div>

            <div className="expertise-group">
              <h4>Software (Electronic)</h4>
              <ul>
                <li>Specialisation in enterprise application development</li>
                <li>Experienced (&gt;15yrs) in the full software development life cycle</li>
                <li>Special interest in open-source software environment</li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
